module.exports = __webpack_public_path__ + "img/Ayalon.92887697.svg";